/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { css } from "styled-components";
import { theme } from "@nordcloud/gnui";

type Props = {
  color?: string;
  margin?: string;
  size?: "xs";
  bold?: boolean;
};

export const Label = styled.p<Props>`
  color: ${theme.color.text.text01};
  font-size: ${theme.fontSizes.md};
  line-height: 1.5em;
  display: inline-block;

  ${({ color }) => css`
    color: ${color};
  `}

  ${({ margin }) => css`
    margin: ${margin};
  `}

  ${({ size }) =>
    size === "xs" &&
    css`
      font-style: normal;
      font-weight: normal;
      font-size: ${theme.fontSizes.xs};
    `}

  ${({ bold }) =>
    bold &&
    css`
      font-weight: bold;
    `}
`;
